import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { WalletIcon } from '@dynamic-labs/wallet-book';
import { useInternalDynamicContext } from '../../context/DynamicContext/useInternalDynamicContext.js';
import { useViewContext } from '../../context/ViewContext/ViewContext.js';
import 'react';
import { Typography } from '../../components/Typography/Typography.js';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../utils/constants/colors.js';
import '../../shared/consts/index.js';
import { pixelToRem } from '../../utils/functions/pixelToRem/pixelToRem.js';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { Button } from '../../components/Button/Button.js';
import '../../components/IconButton/IconButton.js';
import { IconWithSpinner, iconRatio } from '../../components/IconWithSpinner/IconWithSpinner.js';

const WalletSignSpinnerView = () => {
    const { setView } = useViewContext();
    const { setMultiWalletWidgetState, setSelectedWalletConnector, selectedWalletConnector: walletConnector, } = useInternalDynamicContext();
    if (!walletConnector) {
        return null;
    }
    const { name } = walletConnector;
    const iconSize = 80;
    const handleClose = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setView('wallet-list');
        setMultiWalletWidgetState('idle');
        setSelectedWalletConnector(null);
        yield ((_a = walletConnector === null || walletConnector === void 0 ? void 0 : walletConnector.endSession) === null || _a === void 0 ? void 0 : _a.call(walletConnector));
    });
    const icon = (jsx(WalletIcon, { walletName: name, style: {
            height: pixelToRem(iconSize * iconRatio),
            width: pixelToRem(iconSize * iconRatio),
        } }));
    return (jsxs("div", Object.assign({ className: 'wallet-sign-spinner__container', "data-testid": 'wallet-sign-spinner-view' }, { children: [jsx(IconWithSpinner, { Icon: icon, iconSize: iconSize, isSpinning: true }), jsx(Typography, Object.assign({ variant: 'body_normal', className: classNames('wallet-sign-spinner__copy') }, { children: "Sign the message to confirm transferring this wallet to this account." })), jsx(Button, Object.assign({ expanded: true, buttonPadding: 'large', buttonVariant: 'primary', buttonRounded: 'medium', buttonClassName: 'wallet-sign-spinner__button', onClick: () => handleClose(), typographyProps: {
                    variant: 'button_primary',
                    weight: 'medium',
                } }, { children: "Cancel" }))] })));
};

export { WalletSignSpinnerView };
